import React from "react"
import PropTypes from "prop-types"
import { Route, Redirect } from "react-router-dom"
import PrivateRoute from "components/hoc/PrivateRoute"
import { retrieveValues } from "../helpers/storagewrapper.js"

const Authmiddleware = ({
  module: module,
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <>
    {!isAuthProtected ? (
      <Route
        {...rest}
        render={props => {
          return (
            <Layout>
              <Component {...props} />
            </Layout>
          )
        }}
      />
    ) : (
      <PrivateRoute
        module={module}
        isAuthProtected
        {...rest}
        render={props => {
          if (isAuthProtected && !retrieveValues("authUser")) {
            return (
              <Redirect
                to={{ pathname: "/login", state: { from: props.location } }}
              />
            )
          }

          return (
            <Layout>
              <Component {...props} />
            </Layout>
          )
        }}
      />
    )}
  </>
)

Authmiddleware.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any,
  module: PropTypes.string,
}

export default Authmiddleware
